import { api } from '@/lib/api';

export interface MailSettings {
  teamMailbox: string | null;
  senderAddress: string | null;
  updatedAt: string;
  updatedBy: string | null;
}

export const settings = {
  mail: () => api.get<MailSettings>('/api/admin/settings/mail'),
  saveMail: (teamMailbox: string, senderAddress: string) =>
    api.put<MailSettings>('/api/admin/settings/mail', { teamMailbox, senderAddress }),
};
